import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  getPaymentLinks() {
    return this.httpClient.get(this.baseUrl + 'payment');
  }

  cancelSubscription() {
    return this.httpClient.put(this.baseUrl + 'payment/CancelSubscription', null);
  }

  upgradeSubscription(plan: string) {
    var body = { plan: plan };
    return this.httpClient.put(this.baseUrl + `payment/UpgradeSubscription/${plan}`, body);
  }

  createCustomerPortalLink() {
    return this.httpClient.post(this.baseUrl + `payment/CreateCustomerPortalLink`, null);
  }
}
